import { CalloutTarget, setCalloutShown, shouldShowRecentCallout } from 'owa-group-files-hub-store';
import { lighted, LightningId } from 'owa-lightning-v2';
import strings from 'owa-strings/owa-groups-strings';
import { DirectionalHint } from 'office-ui-fabric-react/lib/common/DirectionalHint';
import { IButtonProps, ButtonType } from 'office-ui-fabric-react/lib/Button';
import { TeachingBubble } from 'office-ui-fabric-react/lib/TeachingBubble';
import { observer } from 'mobx-react';
import * as React from 'react';

export interface RecentFilesCalloutProps {
    lid: LightningId;
    target: () => HTMLElement;
}

@observer
export class RecentFilesFRECallout extends React.Component<RecentFilesCalloutProps, {}> {
    render() {
        let gotItButtonProps: IButtonProps = {
            buttonType: ButtonType.primary,
            children: strings.fileshubFREGotIt,
            onClick: this.onClose,
        };

        return (
            shouldShowRecentCallout() && (
                <TeachingBubble
                    calloutProps={{
                        beakWidth: 12,
                        directionalHint: DirectionalHint.rightTopEdge,
                    }}
                    targetElement={this.props.target()}
                    hasCloseIcon={true}
                    onDismiss={this.onClose}
                    hasSmallHeadline={true}
                    headline={strings.fileshubRecentFilesFREHeader}
                    primaryButtonProps={gotItButtonProps}>
                    {strings.fileshubRecentFilesFREBody}
                </TeachingBubble>
            )
        );
    }

    private onClose = () => {
        setCalloutShown(CalloutTarget.RecentFiles);
        lighted(this.props.lid);
    };
}
